import { atom } from "jotai";

import { currentBookingAtom } from "../../stores";

export const anyBookingRatesAtom = atom((get) => {
  const booking = get(currentBookingAtom);

  if (!booking || booking.bookingRates === undefined) {
    return false;
  }

  return booking.bookingRates.length > 0;
});
